<form [formGroup]="form">
  <mat-select formControlName="urlComparisonType">
    <mat-option
      *ngFor="let item of urlComparisonTypesKeys"
      [value]="item"
    >{{ urlComparisonTypes[item] | translate }}
    </mat-option>
  </mat-select>
</form>
